export default __webpack_public_path__ + "src/pages/zesplus/components/Logos/assets/logo-bmbf@2x.png";